import { SET_TRIP, SET_TRAVELER_STATUS } from './types'

const initialState = {
  trip: {},
  status: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TRIP:
      return {
        ...state,
        trip: action.payload,
      }

    case SET_TRAVELER_STATUS:
      return {
        ...state,
        status: action.payload,
      }

    default:
      return state
  }
}
